import LogoSymbol from './logo-symbol-black-white.svg';
export const UprightLogoSymbolBlackWhite = LogoSymbol;
